import React, { useState, useEffect } from 'react';
import { MDBDropdown, MDBDropdownMenu, MDBDropdownToggle, MDBDropdownItem } from 'mdb-react-ui-kit';

export default function PaidPayDropdownButton({ onClick, isPaid, onStatusChange }) {

  const [buttonColor, setButtonColor] = useState(isPaid ? '#A0C2BB' : '#d7a88a');
  const [buttonTitle, setButtonTitle] = useState(isPaid ? 'Paid' : 'Unpaid');

  useEffect(() => {
    setButtonColor(isPaid ? '#A0C2BB' : '#d7a88a');
    setButtonTitle(isPaid ? 'Paid' : 'Unpaid');
  }, [isPaid]);

  const handleDropdownButtonClick = (title) => {
    const newPaidStatus = title === 'Paid';
    
    setButtonColor(newPaidStatus ? '#A0C2BB' : '#d7a88a');
    setButtonTitle(title);
    
    onClick(title); // Invoke the onClick callback with the title
    
    if (isPaid !== newPaidStatus) {
      onStatusChange(newPaidStatus);
    }
  };

  const toggleColorStyle = {
    backgroundColor: buttonColor,
  };

  return (
    <MDBDropdown>
      <MDBDropdownToggle style={toggleColorStyle}>{buttonTitle}</MDBDropdownToggle>
      <MDBDropdownMenu>
        {isPaid ? (
          // Only show Unpaid option when already paid
          <MDBDropdownItem link childTag='button' onClick={() => handleDropdownButtonClick('Unpaid')}>
            Unpaid
          </MDBDropdownItem>
        ) : (
          // Only show Paid option when unpaid
          <MDBDropdownItem link childTag='button' onClick={() => handleDropdownButtonClick('Paid')}>
            Paid
          </MDBDropdownItem>
        )}
      </MDBDropdownMenu>
    </MDBDropdown>
  );
}
